export default {
    methods: {
        currentLang() {
            if (!this.$i18n) {
                return 'en'
            }

            return this.$i18n.locale.value.split('-')[0].replace('dk', 'da')
        },
        setDocumentLang() {
            document.getElementsByTagName('html')[0].lang =
                this.currentLang()
        }
    }
}
